// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"4d68bc58","171":"237a19ad","325":"f0b820ee","648":"61d1afac","747":"44737c24","970":"e32b976e"}[chunkId] + ".chunk.js";
};